<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXCMCarList' }" class="mb-1 btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
              <b-row>
                <b-col>
                  <EXCMCarForm
                    v-if="item"
                    :handle-submit="onSendForm"
                    :handle-update-field="updateField"
                    :values="item"
                    :errors="violations"
                    :initial-values="retrieved" />
                </b-col>
              </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMCarForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMCarForm,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMCarUpdate')
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      isLoading: 'excmcar/update/isLoading',
      error: 'excmcar/update/error',
      deleteError: 'excmcar/del/error',
      deleteLoading: 'excmcar/del/isLoading',
      created: 'excmcar/create/created',
      deleted: 'excmcar/del/deleted',
      retrieved: 'excmcar/update/retrieved',
      updated: 'excmcar/update/updated',
      violations: 'excmcar/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMCarList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmcar/create/reset',
      deleteItem: 'excmcar/del/del',
      delReset: 'excmcar/del/reset',
      retrieve: 'excmcar/update/retrieve',
      updateReset: 'excmcar/update/reset',
      update: 'excmcar/update/update',
      updateRetrieved: 'excmcar/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmcar ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      if (this.retrieved.type) {
        this.retrieved.type = parseInt(this.retrieved.type)
      }
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
